"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { useFaqDrawer } from "@/lib/faq-context";
import type { FaqSettings as FaqSettingsContent } from "@/lib/faqs";

type StoryblokInputEvent = {
  story?: { content?: FaqSettingsContent };
};
type StoryblokBridgeInstance = {
  on: (
    events: string | string[],
    cb: (payload?: StoryblokInputEvent) => void,
  ) => void;
};
type StoryblokBridgeWindow = Window & {
  StoryblokBridge?: new (opts?: object) => StoryblokBridgeInstance;
};

// Preview-only: auto-opens the drawer, pushes live bridge `input` payloads into
// the FAQ context so it re-renders without a save, and router.refresh() on
// `published` to keep the layout in sync.
export default function FaqSettings() {
  const { setOpen, setSettings } = useFaqDrawer();
  const router = useRouter();

  useEffect(() => {
    setOpen(true);
  }, [setOpen]);

  useEffect(() => {
    const w = window as StoryblokBridgeWindow;
    if (!w.StoryblokBridge) return;
    const bridge = new w.StoryblokBridge();
    bridge.on(["input", "change"], (event) => {
      const content = event?.story?.content;
      if (content) setSettings(content);
    });
    bridge.on("published", () => {
      router.refresh();
    });
  }, [router, setSettings]);

  return null;
}
